export class PublisherModel {
    constructor(public id: number, public name: string, public group: string) {
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/publisher.model.ts